import React, { useState } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { AdminShell, LoginCard, Field, Btn, ErrorText, PageTitle } from '../../styles/adminStyles';
import LanguageSwitcher from '../../components/LanguageSwitcher';
import { usePortalT } from '../../i18n/usePortalT';

export default function LoginPage() {
  const { user, isAdmin, login, loading } = useAuth();
  const navigate = useNavigate();
  const { t } = usePortalT();
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [notAdmin, setNotAdmin] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  if (!loading && user && isAdmin) {
    return <Navigate to="/admin" replace />;
  }

  if (loading) {
    return (
      <AdminShell>
        <LoginCard>
          <PageTitle>{t('adminLogin.title')}</PageTitle>
          <p style={{ color: '#64748b', fontSize: 14 }}>{t('common.loading')}</p>
        </LoginCard>
      </AdminShell>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    setNotAdmin(false);
    const out = await login(identifier, password);
    setSubmitting(false);
    if (out.success) {
      navigate('/admin', { replace: true });
    } else if (out.notAdmin) {
      setNotAdmin(true);
      setError(t('adminLogin.notAdmin'));
    } else {
      setError(out.error || t('adminLogin.failed'));
    }
  };

  return (
    <AdminShell>
      <LoginCard>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 8 }}>
          <LanguageSwitcher />
        </div>
        <PageTitle>{t('adminLogin.title')}</PageTitle>
        <p style={{ color: '#64748b', fontSize: 14, marginBottom: 24 }}>
          {t('adminLogin.subtitle')}
        </p>
        <form onSubmit={handleSubmit}>
          <Field>
            {t('adminLogin.userLabel')}
            <input
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              autoComplete="username"
              required
            />
          </Field>
          <Field>
            {t('adminLogin.passwordLabel')}
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </Field>
          {error ? <ErrorText>{error}</ErrorText> : null}
          {notAdmin ? (
            <Btn
              type="button"
              onClick={() => navigate('/organizer/login')}
              style={{ width: '100%', marginTop: 8 }}
            >
              {t('adminLogin.goOrganizer')}
            </Btn>
          ) : null}
          <Btn $primary type="submit" disabled={submitting} style={{ width: '100%', marginTop: 8 }}>
            {submitting ? t('adminLogin.signingIn') : t('adminLogin.signIn')}
          </Btn>
        </form>
        <p style={{ color: '#94a3b8', fontSize: 13, marginTop: 20, textAlign: 'center' }}>
          {t('adminLogin.organizerPrompt')}
          <Link to="/organizer/login" style={{ color: '#2563eb', fontWeight: 600, marginLeft: 4 }}>
            {t('adminLogin.organizerLink')}
          </Link>
        </p>
      </LoginCard>
    </AdminShell>
  );
}
